<mat-card appearance="outlined" class="cardForm">
  <mat-card-header>
    <mat-card-title class="cardTitle">
      <h1 *ngIf="!isEditMode">{{ "orders.createTransmission.title" | translate }}</h1>
      <h1 *ngIf="isEditMode">{{ "orders.editTransmission.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-progress-bar
      *ngIf="isLoading"
      class="progress-bar"
      mode="indeterminate"
      color="accent"
    >
    </mat-progress-bar>

    <div class="introduction" *ngIf="!isEditMode">
      <p>
        Complétez le formulaire ci-dessous pour passer votre commande en ligne.
      </p>

      <p>
        En cas de transport urgent, merci de bien valider la commande par appel
        téléphonique au numéro habituel.
      </p>
    </div>

    <form
      [formGroup]="clientForm"
      *ngIf="!isAdminWithOneClient && !isEditMode && !isLoading"
      class="formClient"
    >
    <section>
      <h3>
        Agence <span class="red">*</span>
      </h3>

      <app-autocomplete
        [control]="getClientControl('client')"
        [list]="clients"
        label="users.edit.clients.select.label"
      >
      </app-autocomplete>
    </section>
    </form>

    <form
      class="edit-form"
      [formGroup]="editForm"
      (submit)="onSubmit()"
      *ngIf="editForm && isFormReady"
    >
      <div class="ordererSiteSection">
        <section>
          <h3>
            Etablissement ({{ "orders.create.site.label" | translate }})
            <span class="red">*</span>
          </h3>
          <p *ngIf="!selectedClient && !isAdminWithOneClient" class="info-message">
            Veuillez d'abord sélectionner une agence ci-dessus
          </p>
          <app-autocomplete
            *ngIf="selectedClient || isAdminWithOneClient"
            [canString]="isDispatcher ? true : false"
            label="orders.create.site.label"
            class="site-field"
            [control]="getControl('site')"
            [list]="filteredSites"
            [setSites]="filteredSites"
            errorMsg="orders.create.site.errorMessage"
          >
          </app-autocomplete>
        </section>

        <section class="ordererSection">
          <h3>Demandeur</h3>
          <div class="ordererFields">
            <mat-form-field class="ordererName-field">
              <mat-label>{{
                "orders.create.ordererName.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererName" />
              <mat-error>
                {{ "orders.create.ordererName.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="ordererPhone-field">
              <mat-label>{{
                "orders.create.ordererPhone.label" | translate
              }}</mat-label>
              <input matInput formControlName="ordererPhone" />
              <mat-error
                >{{ "orders.create.ordererPhone.errorMessage" | translate }}
              </mat-error>
            </mat-form-field>

            <!-- <mat-form-field class="callDate-field">
              <mat-label>Heure d'appel</mat-label>
              <input id="inputTime" type="time" matInput formControlName="callDate">
            </mat-form-field> -->
          </div>
        </section>
      </div>

      <fieldset formGroupName="sender" class="fieldsetSender">
        <legend class="titleLegend">
          Lieu d'enlèvement - Étape 1<span
            class="red"
            >*</span
          >
        </legend>
        <section>
          <h3>Adresse <span class="red">*</span></h3>
          <app-autocomplete
            class="site-field"
            [control]="editForm.get('sender').get('address')"
            [list]="senders"
            errorMsg="orders.create.sender.errorMessage"
            [canString]="canAddOtherAddress"
            [setSites]="senders"
          >
          </app-autocomplete>
        </section>

        <section *ngIf="editForm.get('sender').get('address').value">
          <h3>
            {{ "orders.create.senderService.label" | translate }}
            <span class="red">*</span>
          </h3>

          <ng-container
            *ngIf="
              isTypeOf('string', editForm.get('sender').get('address').value);
              else noString
            "
          >
            <app-autocomplete-text
              class="site-field"
              [control]="editForm.get('sender').get('service')"
              [list]="[]"
              errorMsg="orders.create.senderService.errorMessage"
            >
            </app-autocomplete-text>
          </ng-container>

          <ng-template #noString>
            <app-autocomplete-text
              class="site-field"
              [control]="editForm.get('sender').get('service')"
              [list]="
                editForm.get('sender').get('address').value?.services?.sort()
              "
              errorMsg="orders.create.senderService.errorMessage"
            >
            </app-autocomplete-text>
          </ng-template>
        </section>

        <section>
          <h3>{{ "orders.create.ordererComment.title" | translate }}</h3>
          <mat-form-field class="comment-field">
            <textarea
              matInput
              rows="5"
              formControlName="ordererComment"
            ></textarea>
            <mat-error
              >{{ "orders.create.ordererComment.error" | translate }}
            </mat-error>
          </mat-form-field>
        </section>
      </fieldset>

      <section *ngIf="isControlSet('receivers')">
        <mat-list formArrayName="receivers">
          <mat-list-item
            class="oneReceiver"
            *ngFor="let control of getArray('receivers').controls; index as i"
            [formGroupName]="i"
          >
            <div matLine>
              <fieldset>
                <legend class="titleLegend">
                  <span
                    *ngIf="getArray('receivers').controls.length === 1"
                    >Lieu de livraison -
                  </span>
                  <span>Étape {{ i + 2 }} </span>
                  <span *ngIf="i === 0" class="red">*</span>
                </legend>

                <section
                  *ngIf="getArray('receivers').controls.length > 1"
                >
                  <mat-radio-group formControlName="type">
                    <mat-radio-button value="isDelivery"
                      >Livraison</mat-radio-button
                    >
                    <mat-radio-button value="isPickup"
                      >Enlèvement</mat-radio-button
                    >
                  </mat-radio-group>
                </section>

                <section>
                  <h3>Adresse <span class="red">*</span></h3>
                  <app-autocomplete
                    class="site-field"
                    [control]="control.get('address')"
                    [list]="receivers"
                    errorMsg="orders.create.receiver.errorMessage"
                    [canString]="canAddOtherAddress"
                    [setSites]="receivers"
                  >
                  </app-autocomplete>
                </section>

                <section *ngIf="control.get('address').value">
                  <h3>
                    {{ "orders.create.receiverService.label" | translate }}
                    <span class="red">*</span>
                  </h3>

                  <ng-container
                    *ngIf="
                      isTypeOf('string', control.get('address').value);
                      else noString
                    "
                  >
                    <app-autocomplete-text
                      class="site-field"
                      [control]="control.get('service')"
                      [list]="[]"
                      errorMsg="orders.create.receiverService.errorMessage"
                    >
                    </app-autocomplete-text>
                  </ng-container>

                  <ng-template #noString>
                    <app-autocomplete-text
                      class="site-field"
                      [control]="control.get('service')"
                      [list]="control.get('address').value?.services"
                      errorMsg="orders.create.receiverService.errorMessage"
                    >
                    </app-autocomplete-text>
                  </ng-template>
                </section>

                <section>
                  <h3>
                    {{ "orders.create.ordererComment.title" | translate }}
                  </h3>
                  <mat-form-field class="comment-field">
                    <textarea
                      matInput
                      rows="5"
                      formControlName="ordererComment"
                    ></textarea>
                    <mat-error
                      >{{ "orders.create.ordererComment.error" | translate }}
                    </mat-error>
                  </mat-form-field>
                </section>
              </fieldset>
            </div>
            <button
              *ngIf="i !== 0"
              type="button"
              matTooltip="Retirer
              le destinataire"
              mat-icon-button
              color="primary"
              (click)="onRemoveReceiver(i)"
            >
              <mat-icon aria-label="delete">delete</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item>
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Ajouter un destinataire"
              (click)="onAddReceiver()"
            >
              <mat-icon aria-label="Add">add</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </section>

      <section *ngIf="isControlSet('schedule')" class="date-field">
        <h3>Date, heure de départ souhaitée<span class="red">*</span></h3>
        <mat-list formArrayName="schedule">
          <mat-list-item
            *ngFor="let control of getArray('schedule').controls; index as i"
            [formGroupName]="i"
          >
            <div matLine>
              <mat-form-field class="start-date-field">
                <mat-label>Date</mat-label>
                <input
                  matInput
                  formControlName="startDate"
                  color="primary"
                  [matDatepicker]="startDatePicker"
                  (focus)="startDatePicker.open()"
                  [errorStateMatcher]="confirmValidMatcher"
                  (click)="resetStartDate(control)"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker> </mat-datepicker>
              </mat-form-field>

              <mat-form-field class="start-time-field">
                <mat-label>Heure</mat-label>
                <input
                  id="inputTime"
                  type="time"
                  matInput
                  formControlName="startTime"
                  [errorStateMatcher]="confirmValidMatcher"
                />
              </mat-form-field>
            </div>
            <div
              matLine
              *ngIf="control.hasError('mismatch')"
              class="schedule-error"
            >
              {{ "orders.create.startDate.errorMessage" | translate }}
            </div>
          </mat-list-item>
        </mat-list>
      </section>

      <section>
        <h3>
          {{ "orders.create.transportType.label" | translate }}
          <span class="red">*</span>
        </h3>

        <mat-form-field class="devicesChipList">
          <mat-chip-grid #chipList aria-label="Device selection">
            <mat-chip-row
              *ngFor="let selected of transportTypesSelected"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(selected)"
            >
              {{ selected.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
            <input
              placeholder="Sélectionnez un type de produit"
              #deviceInput
              id="deviceChipList"
              [formControl]="transportTypesCtrl"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
            />
            <button
              type="button"
              mat-icon-button
              color="primary"
              *ngIf="transportTypesSelected.length > 0"
              (click)="clearDevicesSelected()"
            >
              <mat-icon class="clearButton" (click)="clearDevicesSelected()"
                >clear</mat-icon
              >
            </button>
          </mat-chip-grid>
          <mat-autocomplete
            class="devicesDropdown"
            #auto="matAutocomplete"
            (optionSelected)="selected($event)"
          >
            <mat-option
              *ngFor="let device of filteredTransportTypes | async"
              [value]="device"
              [disabled]="device.selected"
            >
              {{ device.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </section>

      <section>
        <h3>
          {{ "orders.create.urgencyLevel" | translate }}
          <span class="red">*</span>
        </h3>
        <mat-radio-group
          aria-label="Sélectionnez un niveau d'urgence"
          class="urgency-field"
          formControlName="urgencyLevel"
        >
          <mat-radio-button
            *ngFor="let urgencyLevel of urgencyLevels"
            [value]="urgencyLevel"
            >{{ urgencyLevel.name }}
          </mat-radio-button>
        </mat-radio-group>
      </section>

      <section>
        <h3>Commentaires sur la course</h3>
        <mat-form-field class="comment-field">
          <textarea
            matInput
            rows="5"
            formControlName="ordererComment"
          ></textarea>
          <mat-error
            >{{ "orders.create.ordererComment.error" | translate }}
          </mat-error>
        </mat-form-field>
      </section>

      <section class="actions">
        <div
          class="checkButton"
          [matTooltip]="invalidMessage"
          [matTooltipDisabled]="
            editForm.valid &&
            transportTypesSelected.length !== 0 &&
            this.editForm.value.receivers[
              this.editForm.value.receivers.length - 1
            ].type !== 'isPickup'
          "
        >
          <button
            *ngIf="!isLoading"
            type="submit"
            mat-raised-button
            color="primary"
            [disabled]="
              editForm.invalid ||
              transportTypesSelected.length === 0 ||
              this.editForm.value.receivers[
                this.editForm.value.receivers.length - 1
              ].type === 'isPickup'
            "
          >
            {{ "global.validateAndCancel.validate" | translate }}
          </button>
        </div>

        <button
          *ngIf="!isLoading"
          type="button"
          mat-raised-button
          color="primary"
          (click)="onFinish()"
        >
          {{ "global.validateAndCancel.cancel" | translate }}
        </button>

        <mat-spinner
          *ngIf="isLoading"
          [diameter]="35"
          color="primary"
        ></mat-spinner>
      </section>
    </form>
  </mat-card-content>
</mat-card>
